import { i18n } from '../../i18n';
import { request } from 'beans-admin-plugin';



export const filterColumnsHash = {
  slug_cont: {
    label: i18n.t('page.slug'),
    renderCell: {
      component: 'input'
    }
  },
  title_cont: {
    label: i18n.t('page.title'),
    renderCell: {
      component: 'input'
    }
  },
  application_id_eq: {
    label: i18n.t('page.application'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        xRemotePreload: async () => {
          const { data } = await request.get('/applications', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.name }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { name_cont: keyword };
          const { data } = await request.get('/applications', { params });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('page.id'),
    width: 80,
  },
  slug: {
    label: i18n.t('page.slug'),
  },
  title: {
    label: i18n.t('page.title'),
  },
  type: {
    label: i18n.t('page.type'),
  },
  application_id: {
    label: i18n.t('page.application'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.application) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'applications.show', params: { id: row.application_id } }}>{row.application.name}</bean-link>
    },
  },
  views_count: {
    label: i18n.t('page.viewsCount'),
  },
  created_at: {
    label: i18n.t('page.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('page.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  wxacode: {
    label: i18n.t('page.wxacode'),
    width: 120,
    renderCell: 'storageAttachment',
  },
  content: {
    label: i18n.t('page.content'),
    renderCell: 'html',
  },
}

export const formColumnsHash = {
  slug: {
    label: i18n.t('page.slug'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  title: {
    label: i18n.t('page.title'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  type: {
    label: i18n.t('page.type'),
    renderCell: {
      component: 'input',
    },
  },
  content: {
    label: i18n.t('page.content'),
    renderCell: {
      required: true,
      component: 'editor',
    }
  },
}
